<template>
    <section class="resume-section skills-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">{{translations.title}}</h2>
        <div class="resume-section-content">
            <div v-for="(category, index) in categories" :key="index" class="resume-skill-item">
                <h4 class="resume-skills-cat font-weight-bold">{{category.title}}</h4>
                <ul class="list-unstyled" :class="{'mb-4': !index}">
                    <li v-for="(knowledge, kIndex) in category.list" :key="kIndex" class="mb-2">
                        <div class="resume-skill-name">
                            {{knowledge.name}}:
                            <h6 class="font-weight-bold d-inline">
                                {{translations.levels[knowledge.level]}}
                            </h6>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="others.length" class="resume-skill-item">
                <h4 class="resume-skills-cat font-weight-bold">{{translations.others}}</h4>
                <ul class="list-inline">
                    <li v-for="(knowledge, index) in others" :key="index" class="list-inline-item">
                        <span class="badge badge-light">{{knowledge}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: "Skills",
        computed: {
            categories() {
                return this.$store.state.skills.categories;
            },
            others() {
                return this.$store.state.skills.others;
            },
            translations() {
                return this.$store.state.skills.i18n[this.$store.state.config.lang];
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "./../../sass/constants"
    .resume-skills
        &-cat, &-name
            color: $gray-blue

        &-cat
            font-size: 1rem

        &-name
            font-size: 0.8125rem

</style>